import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CollapsibleCard from './CollapsibleCard';
import { useTranslation } from '../hooks/i18n';

const INFO_CARDS = ['benefits', 'notRegistered', 'dontKnow', 'lostPassword', 'noHandy', 'representative'];

interface SATHelpDrawerProps {
  open: boolean;
  onClose: () => void;
}

const SATHelpDrawer = ({ open, onClose }: SATHelpDrawerProps) => {
  const { t } = useTranslation(['application']);

  return (
    <Drawer anchor="right" open={open} sx={{ borderRadius: '20px' }} onBackdropClick={onClose}>
      <Box sx={{ padding: '2em', display: 'flex', flexDirection: 'column', gap: '1em' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h5" sx={{ flex: 1 }}>
            {t('application:sections.taxInformation.drawer.title')}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {INFO_CARDS.map((name) => (
          <CollapsibleCard
            key={name}
            title={t(`application:sections.taxInformation.drawer.${name}.title`)}
            content={
              <div
                dangerouslySetInnerHTML={{
                  __html: t(`application:sections.taxInformation.drawer.${name}.description`),
                }}
              />
            }
            sx={{ width: '500px' }}
          />
        ))}
      </Box>
    </Drawer>
  );
};

export default SATHelpDrawer;
